import React, { ReactNode } from "react";
import { GrFormClose } from "react-icons/gr";

type Props = {
  open: boolean;
  close?: () => void;
  canClose?: boolean;
  children: ReactNode;
};

const ModalContainer = ({ open, close, canClose = true, children }: Props) => {
  return (
    /* z-[60], the notification drawer's tier: above the sticky Navbar (z-40),
       MobileMenu (z-50) and PageLoader (z-[55]). At z-30 the header sat on top
       of every modal built on this container, so the Profile/Refer bar cut
       across the profile editors and the complete-your-profile blocker.
       Toasts stay above it at react-toastify's own z-index (9999), and the
       portalled ui/select, ui/popover and ui/tooltip sit at z-[70] so their
       menus still open over the editors inside it.

       The panel sized itself to its content with nothing to stop it, so a
       form laid out for a desktop simply ran off the side of a phone — which
       is what talents were hitting when they tried to update a CV. The
       backdrop now holds a gutter and the panel is capped to the viewport, so
       anything too big scrolls instead of escaping the page. */
    <div
      className={`z-[60] ${
        open ? "flex" : "flex -translate-y-full"
      } transition-ease fixed inset-0 w-full items-center justify-center overflow-y-auto bg-black/60 p-3 sm:p-4`}
    >
      <section
        className={`relative z-20 flex max-h-[92vh] w-full max-w-[100%] flex-col space-y-3 overflow-y-auto rounded-lg bg-white px-2 py-5 sm:w-auto sm:max-w-[92vw]`}
      >
        {canClose && (
          <div
            onClick={close}
            className="absolute text-black right-5 top-5 block hover:cursor-pointer"
          >
            <GrFormClose className="h-6 w-6" />
          </div>
        )}

        {children}
      </section>
    </div>
  );
};

export default ModalContainer;
